import {
  CardButtonSmallRounded,
  GroupElement,
  InfoBanner,
  PaymentsOutlineMediumIcon,
  PreverAngelusFillMediumIcon,
  ProductSalePlansOutlineMediumIcon,
  Section,
  TextLink,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { SkeletonProductSection } from '../../components/skeletons/SkeletonSection';
import { useFormattedPlanRoutes } from './home.store';
import { ProductSection } from './ProductSection';
import { StyledGroupElementScroll } from './StyledGroupElementScroll';

export const PlanSection = () => {
  const { hasContract, items, product, routes, isLoading } =
    useFormattedPlanRoutes();

  if (isLoading) {
    return <SkeletonProductSection />;
  }

  if (hasContract) {
    return (
      <ProductSection product={product} color={product.color} items={items} />
    );
  }

  return (
    <Section>
      <InfoBanner>
        <GroupElement>
          Se você já é um associado, precisa vincular seu plano para que possa
          acessá-lo por aqui.
          <LinkWrapper href={routes['Vincular Plano']}>
            <TextLink>Vincular meu plano</TextLink>
          </LinkWrapper>
        </GroupElement>
      </InfoBanner>

      <StyledGroupElementScroll>
        <LinkWrapper href={routes['Vincular Plano']}>
          <CardButtonSmallRounded
            icon={<PreverAngelusFillMediumIcon color={product.color} />}
            label="Vincular Plano"
          />
        </LinkWrapper>
        <LinkWrapper href={routes['Adquirir Plano']}>
          <CardButtonSmallRounded
            icon={<ProductSalePlansOutlineMediumIcon color={product.color} />}
            label="Adquirir Plano"
          />
        </LinkWrapper>
        <LinkWrapper href={routes['Indique e ganhe']}>
          <CardButtonSmallRounded
            icon={<PaymentsOutlineMediumIcon color={product.color} />}
            label="Indique e ganhe"
            tagContent="NOVO"
          />
        </LinkWrapper>
      </StyledGroupElementScroll>
    </Section>
  );
};
